// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonSpinnerLoader {\n  position: absolute;\n  width: 50px;\n  height: 50px; }\n", "",{"version":3,"sources":["webpack://src/components/_common/ButtonSpinner.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA","sourcesContent":[".buttonSpinnerLoader {\n    position: absolute;\n    width: 50px;\n    height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
